import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { OrderSetup } from "../../../Common/OrderSetup/OrderSetup";

interface IOrderSetupProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface IOrderSetupState {}

export class SellOrderSetup extends ProcessComponent<IOrderSetupProps, IOrderSetupState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, type, onChange } = this.props;

        return (
            <OrderSetup
                data={data}
                type={type}
                onChange={(changes) => onChange(changes)}
                onRef={(ref) => this.appendChild(ref)}
                process={ProcessType.Sell}
            />
        );
    }
}
